import { Directive, ElementRef, HostListener, Input, OnChanges, Renderer2, SimpleChanges, inject } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Directive({
    selector: '[appNgSelect]',
    standalone: false
})
export class NgSelectDirective implements OnChanges {
  private element = inject(ElementRef);
  private renderer = inject(Renderer2);
  private ngSelect = inject(NgSelectComponent, { self: true, optional: true });

  @Input() appNgSelect: any;

  constructor() {
    // this.elementHasValClassChanges();
    setTimeout(() => {
      this.elementHasValClassChanges();
    }, 500);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      // if (this.appNgSelect !== null) {
        setTimeout(() => {
          this.elementHasValClassChanges();
        });
      // }
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    const selectedValueClicked = !!target?.closest('.ng-value');
    const removeValueClicked = !!target?.closest('.ng-value-icon');
    const clearClicked = !!target?.closest('.ng-clear-wrapper');
    const arrowClicked = !!target?.closest('.ng-arrow-wrapper');

    if (selectedValueClicked && !removeValueClicked && !clearClicked && !arrowClicked) {
      event.preventDefault();
      this.ngSelect?.open();
    }

    this.elementHasValClassChanges();
  }

  @HostListener('blur') onBlur() {
    setTimeout(() => {
      this.elementHasValClassChanges();
    });
  }

  private elementHasValClassChanges(): void {
    const getElement = this.element?.nativeElement;
    const allChildres = getElement?.children as HTMLCollection;
    if (allChildres && allChildres?.length == 0) {
      return;
    }
    const getChild = allChildres?.item(0);
    if (getChild?.classList?.contains('ng-has-value')) {
      this.renderer?.addClass(this.element?.nativeElement, 'hasValueChange');
      this.renderer?.addClass(this.element?.nativeElement, 'hasMultiValueChange');
    } else {
      this.renderer?.removeClass(this.element?.nativeElement, 'hasValueChange');
      this.renderer?.removeClass(this.element?.nativeElement, 'hasMultiValueChange');
    }
  }

}
